<div class="tango-wrapper">
  <div class="container">
    <h1>Do you need a Tango refresher? Are you new to the tool? Click below to access the latest in Tango training.</h1>
    <!--<a style="color: #bebebe; text-decoration: none; font-size: 16px;" target="_blank" href="https://learning.ultipro.com/7954290/isg-tango-training">https://learning.ultipro.com/7954290/isg-tango-training</a>-->
    <a style="color: #bebebe; text-decoration: none; font-size: 16px;" target="_blank" href="https://learning.ultipro.com/8553213/isg-tango-demo-updates">https://learning.ultipro.com/8553213/isg-tango-training</a>
    <div class="logo">
      <img src="../../../../../../assets/images/workbench/tango.svg" alt="ISG Tango">
    </div>
  </div>
</div>
